
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.475.875c-3.357 0-6.1 2.744-6.1 6.1 0 3.357 2.743 6.1 6.1 6.1 3.357 0 6.1-2.743 6.1-6.1 0-3.357-2.743-6.1-6.1-6.1zm2.761 7.774A.769.769 0 019.15 9.737L7.475 8.062 5.8 9.737a.769.769 0 01-1.088-1.088l1.675-1.674-1.675-1.674a.769.769 0 011.088-1.087l1.674 1.674 1.674-1.674A.769.769 0 0110.236 5.3L8.562 6.975l1.674 1.674z","fill":"#D3D7E1"}})])
          )
        }
      }
    